import { END_POINTS } from "../constants/urls";
import { CommonResponseType } from "../types/General";
import emptySplitApi from "../utils/rtk";

// interface CommonResponseType {
//   status: number;
//   message: string;
//   statusCode: number;
// }

export interface AccessRoleData {
  _id: string;
  name: string;
  permissions: Permission[];
  isBlocked: boolean;
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
}

export interface Permission {
  label: string;
  isView: boolean;
  isAdd: boolean;
  isDelete: boolean;
  isEdit: boolean;
  isSubMenu: boolean;
  _id: string;
  subMenuItems: SubMenuItem[];
  id: string;
}

export interface SubMenuItem {
  label: string;
  isView: boolean;
  isAdd: boolean;
  isDelete: boolean;
  isEdit: boolean;
  isSubMenu: boolean;
  _id: string;
  id: string;
}

export const roleApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getRole: builder.query<
      CommonResponseType & { data: any },
      {
        page?: any;
        limit?: any;
        search?: any;
      }
    >({
      query: (params) => {
        const paramArray = [];
        let url = END_POINTS.getSubAdminRole;
        if (params?.page) {
          paramArray.push(`page=${params?.page}`);
        }
        if (params?.limit) {
          paramArray.push(`limit=${params?.limit}`);
        }
        if (params?.search) {
          paramArray.push(`search=${params?.search}`);
        }
        if (paramArray?.length) {
          url += `?${paramArray.join("&")}`;
        }
        return {
          url: url,
          method: "GET",
        };
      },
    }),
    getDropDownList: builder.query<CommonResponseType & { data: any }, void>({
      query: () => {
        return {
          url: END_POINTS.getRoleDropDownList,
          method: "GET",
        };
      },
    }),
    getRoleById: builder.query<CommonResponseType & { data: any }, { id: any }>(
      {
        query: ({ id }) => ({
          url: `${END_POINTS.getSubAdminByIdRole}/${id}`,
          method: "GET",
        }),
      }
    ),
    addRole: builder.mutation<CommonResponseType, {}>({
      query: (body) => ({
        url: END_POINTS.addsubAdminRole,
        method: "POST",
        body,
      }),
    }),
    updateRole: builder.mutation<CommonResponseType, { body: any; id: any }>({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateSubAdminRole}/${id}`,
        method: "PUT",
        body,
      }),
    }),
    deleteRole: builder.mutation<CommonResponseType, { id: any }>({
      query: ({ id }) => ({
        url: `${END_POINTS.deleteSubAdminRole}/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useAddRoleMutation,
  useLazyGetRoleByIdQuery,
  useGetRoleByIdQuery,
  useLazyGetRoleQuery,
  useGetRoleQuery,
  useUpdateRoleMutation,
  useDeleteRoleMutation,
  useGetDropDownListQuery,
} = roleApi;
